export default __webpack_public_path__ + "static/media/bg-2.510dcc95.png";